import {isNullOrUndefined} from "../../../services/Validator";
import GlossaryStarDivider from "../../dividers/glossaryScreen/GlossaryStarDivider";
import GlossaryTermWordText from "../../texts/glossaryScreen/GlossaryTermWordText";
import GlossaryTermDefinitionText from "../../texts/glossaryScreen/GlossaryTermDefinitionText";
import {useState} from "react";
import {useResizeListener} from "../../../listeners/SystemResizeListener";
import GlossaryDetailedScreen from "../../../screens/glossary/GlossaryDetailedScreen";
import {kSystemIcons} from "../../../constants/icons";

export default function GlossaryTermItem({term, isFirst, highlight, search}) {
    // Used in GlossaryLettersList to display one single letter

    // PROPERTIES
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isHovered, setIsHovered] = useState(false)

    // HOOKS
    // ---- Eventually close modal during screen resize
    useResizeListener(() => setIsModalOpen(false))

    // BUILD
    if (isNullOrUndefined(term))
        return null
    return (
        <div className={"w-full flex flex-col px-[8px] mt-[12px]"}>
            {/** TERM MODAL */}
            <GlossaryDetailedScreen open={isModalOpen}
                                    handleClose={processModalClosing}
                                    term={term} />
            {/** CORE */}
            {!isFirst && ( <GlossaryStarDivider />)}
            <div className={"cursor-pointer w-full flex"}
                 onClick={processModalOpening}
                 onMouseEnter={() => setIsHovered(true)}
                 onMouseLeave={() => setIsHovered(false)}>
                <div className={"w-full flex flex-col space-y-[2px] px-[12px]"}>
                    <GlossaryTermWordText word={term.word}
                                          search={search}
                                          highlight={highlight} />
                    <GlossaryTermDefinitionText definition={term.definition}
                                                search={search}
                                                highlight={highlight} />
                </div>
                <i className={`material-icons text-[20px] ${isHovered ? "text-greyLight9" : "text-greyLight7"}`}>
                    {kSystemIcons.more}
                </i>
            </div>

        </div>
    );

    // METHODS
    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isModalOpen) {
            setIsModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isModalOpen) {
            setIsModalOpen(false)
        }
    }
}